module.exports = __webpack_public_path__ + "img/li.e45cca36.svg";